import type { NotificationListItem } from "@slfinrtl/ui-bff-routes"
import { trackEvent } from "src/components/adobeAnalytics"

type BaseAction =
	| "mark_as_read" //
	| "open_notification"
	| "open_notification_settings"

type CenterAction =
	| BaseAction
	| "activate_only_read_filter"
	| "deactivate_only_read_filter"
	| `change_group_${NotificationListItem["group"] | "all"}`
	| "mark_as_unread"

type PopoverAction =
	| BaseAction //
	| "open_popover"
	// | "close_popover" // NOTE: not possible until component is actually controlled
	| `open_notification_center`

export const trackNotificationCenterEvent = (action: CenterAction) => {
	trackEvent({ action, category: "notification_center" })
}

export const trackNotificationCenterPopoverEvent = (action: PopoverAction) => {
	trackEvent({ action, category: "notification_center_popover" })
}
